import { BILLING_PAYMENT_STATUS_DISPLAY_ORDER } from "../constants/billing";
import { BillingPaymentsPayment, BillingPaymentStatus } from "../types/billing";

export const calculateDisplayPaymentStatus = (payments: BillingPaymentsPayment[]) => {
  if (!payments) return BillingPaymentStatus.Paid;

  const statuses = payments.map(payment => payment.status);
  const firstStatus = BILLING_PAYMENT_STATUS_DISPLAY_ORDER.find(status =>
    statuses.includes(status)
  );

  return firstStatus ?? BillingPaymentStatus.Paid;
};
